import React from "react";
import styled from "styled-components";
import { Form, Select } from "antd";
import Mutation from "react-apollo/Mutation";
import Button from "../../components/common/Button";
import REQUEST_VERIFICATION from "../../graphql/mutations/REQUEST_VERIFICATION";
const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class RequestVerification extends React.Component {
  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = async (e, mutation) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
      }
      try {
        const { data } = await mutation({ variables: values });
        // retrieve token, persist it and route back to home
        this._handleNextRoute();
      } catch (e) {
        console.log("Error signing up: ", e);
      }
    });
  };

  _handleNextRoute = () => this.props.history.push("/auth/verify_user");

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    return (
      <Mutation mutation={REQUEST_VERIFICATION}>
        {(mutation, { loading, error, data }) => {
          return (
            <Form onSubmit={e => this.handleSubmit(e, mutation)}>
              <FormItem>
                {getFieldDecorator("verificationType", {
                  rules: [
                    {
                      required: true,
                      message: "Please select a method for vericiation"
                    }
                  ]
                })(
                  <Select placeholder="Select either phone or email">
                    <Option value="EMAIL">Email</Option>
                    <Option disabled value="PHONE">
                      Phone
                    </Option>
                  </Select>
                )}
              </FormItem>
              <FormItem>
                <Button
                  disabled={hasErrors(getFieldsError())}
                  block
                  type="primary"
                  htmlType="submit"
                  text="Request Verification Code"
                  buttonColor="yellow"
                />
              </FormItem>
            </Form>
          );
        }}
      </Mutation>
    );
  }
}

const WrappedRequestVerificationScreen = Form.create()(RequestVerification);

export default WrappedRequestVerificationScreen;
